import script from "./Ratings.vue?vue&type=script&setup=true&lang=js"
export * from "./Ratings.vue?vue&type=script&setup=true&lang=js"

import "./Ratings.vue?vue&type=style&index=0&id=54aef9fc&lang=scss"
import "./Ratings.vue?vue&type=style&index=1&id=54aef9fc&lang=scss&scoped=true"

import exportComponent from "/tmp/tesla_data/tmp/apply_3091/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54aef9fc"]])

export default __exports__